module.exports = __webpack_public_path__ + "img/LogoEmblemWatermark.61e81c03.png";